module.exports = __webpack_public_path__ + "static/media/bed.fd2928b7.svg";